import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

//UAT

// const firebaseConfig = {
//   apiKey: "AIzaSyAEcXgh78EIK7OuH9l5mxlvFh8MVlYmHm8",
//   authDomain: "queen-uat-ad273.firebaseapp.com",
//   projectId: "queen-uat-ad273",
//   storageBucket: "queen-uat-ad273.firebasestorage.app",
//   messagingSenderId: "222900624963",
//   appId: "1:222900624963:web:8d0bb3cc62092dd818bef6",
//   measurementId: "G-YFWZKN45Z2"
// };

const firebaseConfig = {
  apiKey: "AIzaSyDrk9zhtADpI8MYYObaaDoR25PUqg7lHKM",
  authDomain: "queen-live-72d4a.firebaseapp.com",
  projectId: "queen-live-72d4a",
  storageBucket: "queen-live-72d4a.firebasestorage.app",
  messagingSenderId: "489989700102",
  appId: "1:489989700102:web:ba5b425f7a1ca2a7c52187",
  measurementId: "G-WK5XV4ZTRN"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
